/**
 * Le signal Bugsnag d'un fichier choisi qui ne se lit plus, sur le web — celui de
 * `CommonChat.uploadPart` (`notifyBugsnag`, même `step`). Le web lit `@bugsnag/js`, que
 * `common/utils/initBugsnag.web.js` démarre ; `@bugsnag/expo` ne s'y évalue pas (sa file d'envoi
 * lit le cache de `expo-file-system` au chargement).
 */
import Bugsnag from "@bugsnag/js"

export function reportUnreadableFile(error: unknown, uri: string) {
    if (__DEV__) return
    Bugsnag.notify(error as Error, (event) => {
        event.addMetadata("context", { step: "chat upload: file unreadable", uriScheme: uri.split(":")[0] })
    })
}
